export default {
  SET_RESULTS: 'RF_SET_RESULTS',
  UPDATE_RESULT: 'RF_UPDATE_RESULT',
  UPDATE_INDICATOR: 'RF_UPDATE_INDICATOR',
  UPDATE_PERIOD: 'RF_UPDATE_PERIOD',
  UPDATE_ITEM: 'RF_UPDATE_ITEM',
  DELETE_ITEM: 'RF_DELETE_ITEM',
  TOGGLE_LOCK_PERIOD: 'RF_TOGGLE_LOCK_PERIOD',
  BULK_UPDATE_STATUS: 'RF_BULK_UPDATE_ITEMS'
}
